import React,{useMemo} from "react";

import { fetchChannels, fetchEpg } from "./helpers";

import { useEpg } from "planby";
// import Global from "../../global"
import { startOfToday, startOfTomorrow } from 'date-fns';

// Import theme
import { theme } from "./helpers/theme";
import { is12HourClock } from "../javascript/function";

export function useApp() {
  const [channels, setChannels] = React.useState([]);
  const [epg, setEpg] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  const channelsData = React.useMemo(() => channels, [channels]);
  const epgData = React.useMemo(() => epg, [epg]);
  //const date = startOfToday().toJSON();
  // const [startDate, endDate] = useMemo(() => [startOfToday(), startOfTomorrow()], [date]);
  const [startDate, endDate] = useMemo(() => [startOfToday(), startOfTomorrow()],[]);
  const isBaseTimeFormat = is12HourClock();

  const { getEpgProps, getLayoutProps } = useEpg({
    channels: channelsData,
    epg: epgData,
    dayWidth: 7200,
    sidebarWidth: 100,
    itemHeight: 80,
    isSidebar: true,
    isTimeline: true,
    isRTL:true,
    isLine: true,
    isBaseTimeFormat: isBaseTimeFormat,
    startDate:startDate,
    endDate:endDate,
    theme
  });

  const handleFetchResources = React.useCallback(async () => {
    setIsLoading(true);
    const epg = await fetchEpg();
    const channels = await fetchChannels();
    setEpg(epg);
    setChannels(channels);
    setIsLoading(false);
  }, []);

  React.useEffect(() => {
    handleFetchResources();
  }, [handleFetchResources]);

  return { getEpgProps, getLayoutProps, isLoading, isBaseTimeFormat };
}
